export default __webpack_public_path__ + "static/media/Gallery15.8221a3d9.jpg";